module.exports = __webpack_public_path__ + "img/img08.8ce98a1c.jpeg";